module.exports = __webpack_public_path__ + "static/media/THG.f5fccaa6.png";